import React from 'react';
import { Link } from 'react-router-dom';
import { formatNum } from '../../utils/dashboardFormatters';

export default function DashboardPriorityAlerts({ alerts, loading }) {
  return (
    <div className="db-card">
      <div className="db-card-header">
        <div className="db-card-title">
          <i className="fas fa-triangle-exclamation" style={{ color: '#DC2626' }} />
          Priority alerts
        </div>
      </div>
      <div className="db-card-body">
        {loading ? (
          <div className="db-skeleton-block" style={{ minHeight: 120 }} />
        ) : !alerts?.length ? (
          <div className="db-empty" style={{ padding: 24 }}>
            <i className="fas fa-circle-check" style={{ color: '#16A34A' }} />
            <p>All clear — no priority items</p>
          </div>
        ) : (
          <ul className="db-alert-list">
            {alerts.map((a) => (
              <li key={a.id || a.alertKey} className={`db-alert-item db-alert-sev-${a.severity || 'low'}`}>
                <Link to={a.href || '#'}>{a.type}</Link>
                <span className="db-alert-count">{formatNum(a.count)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
